import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateGroupRequirementsApi = createApi({
  reducerPath: 'policyTemplateGroupRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getGroupRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/group-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetGroupRequirementsPreviewQuery, useLazyGetGroupRequirementsPreviewQuery } =
  policyTemplateGroupRequirementsApi

export const useGroupRequirementsPreview = ({ templateId, customerId: customerIdOverride }, options = {}) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  const customerId = customerIdOverride ?? selectedCustomerId

  // Always re-resolve on mount: groups can be created or deleted in Entra between review visits,
  // so a cached "matched" result would contradict the live state (and Impact Analysis).
  const result = useGetGroupRequirementsPreviewQuery(
    { templateId, customerId },
    { refetchOnMountOrArgChange: true, ...options, skip: options.skip || !templateId || !customerId },
  )

  // Withhold the cached result while re-resolving so the review shows the loading skeleton
  // instead of a stale status that may be about to change.
  return { ...result, data: result.isFetching ? undefined : result.data }
}
